import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavigatableDetail } from 'src/app/common-components/detail/detail';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { getPhoneNumberPrivileges } from 'src/app/privileges/privileges.selector';
import { phoneNumberRegisterAdapterActions } from '../../phone-number-register/state/phone-number-register.actions';
import { selectTotalCount } from '../../phone-number-register/state/phone-number-register.reducer';
import {
   PhoneNumberDetailDeleteEvent,
   PhoneNumberDetailSaveEvent,
} from '../models/phone-number-detail-form-submit-event';
import { PhoneNumberDetailView } from '../models/phone-number-detail-view.model';
import { PhoneNumberPrivileges } from '../models/phone-number-privileges';
import { PhoneNumberDetailFormService } from '../services/phone-number-detail-form.service';
import * as PhoneNumberDetailActions from '../state/phone-number-detail.actions';
import { getPhoneNumber, getPhoneNumberCallState, selectNonSystemIds } from '../state/phone-number-detail.selectors';

@Component({
    encapsulation: ViewEncapsulation.None,
    host: { class: 'entity-detail' },
    providers: [PhoneNumberDetailFormService, { provide: FormsBase, useExisting: PhoneNumberDetailFormService }],
    selector: 'ndt-phone-number-detail',
    templateUrl: './phone-number-detail.component.html',
    standalone: false
})
export class PhoneNumberDetailComponent
   extends NavigatableDetail<PhoneNumberDetailFormService>
   implements OnInit, OnDestroy
{
   phoneNumber$: Observable<PhoneNumberDetailView | null>;

   callState$: Observable<CallState>;

   phoneNumberPrivileges$: Observable<PhoneNumberPrivileges>;

   constructor(public store: Store, private router: Router, protected formService: PhoneNumberDetailFormService) {
      super(store, formService);
      this.phoneNumber$ = this.store.pipe(select(getPhoneNumber));
      this.callState$ = this.store.pipe(select(getPhoneNumberCallState));
      this.phoneNumberPrivileges$ = this.store.pipe(select(getPhoneNumberPrivileges));
      this.store.dispatch(PhoneNumberDetailActions.phoneNumberDetailLoad());
   }

   ngOnInit(): void {
      this.idsFromRegister$ = this.store.pipe(select(selectNonSystemIds));
      this.totalCount$ = this.store.pipe(select(selectTotalCount));
      this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((e) => {
         if (e instanceof NavigationEnd) {
            this.store.dispatch(PhoneNumberDetailActions.phoneNumberDetailLoad());
         }
      });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
      this.destroyed$.complete();
   }

   onFormSaveCanceled(): void {
      this.store.dispatch(PhoneNumberDetailActions.phoneNumberDetailCancel());
   }

   onFormSubmitted(event: PhoneNumberDetailSaveEvent): void {
      this.store.dispatch(PhoneNumberDetailActions.savePhoneNumberDetail(event));
   }

   onNumberReleased(event: PhoneNumberDetailSaveEvent): void {
      this.store.dispatch(PhoneNumberDetailActions.releasePhoneNumberDetail(event));
   }

   onNumberDeleted(event: PhoneNumberDetailDeleteEvent): void {
      this.store.dispatch(PhoneNumberDetailActions.deletePhoneNumberDetailFromNDT(event));
   }

   onNavigate(id: string | number) {
      this.store.dispatch(PhoneNumberDetailActions.navigate({ id }));
   }

   onLoadIdPage() {
      this.store.dispatch(phoneNumberRegisterAdapterActions.loadIdPage());
   }
}
